import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-auto-neo',
  templateUrl: './auto-neo.component.html',
  styleUrls: ['./auto-neo.component.css']
})
export class AutoNeoComponent implements OnInit {

  constructor() {
    this.autoUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.valueChange.emit(this.AutoValue);
      });
  }

  @Input() options: any;
  @Input() placeholder: any;
  @Input() AutoValue: string;
  @Input() appearance: string;

  autoUpdate = new Subject<string>();

  @Output() valueChange = new EventEmitter();
  @Output() valueFinal = new EventEmitter();

  valueChanged() {
    this.valueFinal.emit(this.AutoValue);
  }

  ngOnInit() {
    if (!this.appearance) {
      this.appearance = 'standard';
    }
    // console.log(this.options);
  }

}
